"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const JsonLd = (props) => {
    const { children, location, pageContext, data, globalData } = props;
    if (data && pageContext?.originalId && Object.entries(data).find(([a, b]) => b.jsonLd)?.[1]?.jsonLd) {
        const json = Object.entries(data).find(([a, b]) => b.jsonLd)?.[1]?.jsonLd;
        if (typeof json === "string") {
            return (react_1.default.createElement("script", { type: "application/ld+json", dangerouslySetInnerHTML: { __html: json } }));
        }
        return null;
    }
    if (pageContext.originalId) {
        // Is Dato but missing jsonLd, throw
        throw new Error(`Data on this page is derived from Dato, but the 'jsonLd' field has not been included on the template's query. Please add it.`);
    }
    return null;
};
exports.default = JsonLd;
//# sourceMappingURL=index.js.map